export default __webpack_public_path__ + "static/media/salil.5d295d68.jpg";